import { AuthenticationGroupDetailsSession } from "@cofano/coastguard2-frontend-client";
import { Clear } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { intl } from "LocaleWrapper";

export type SessionSelectApplicationProps = {
	session: AuthenticationGroupDetailsSession;
	currentSessionUuid: string | null;
	switchSession: (sessionUuid: string) => void;
	logoutSession: (sessionUuid: string) => void;
};

const CoastguardSessionSelectApplication = ({
	session,
	currentSessionUuid,
	switchSession,
	logoutSession,
}: SessionSelectApplicationProps) => {
	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="space-between"
			sx={{
				paddingX: 1,
				paddingY: 0.5,
				backgroundColor: (theme) => theme.palette.background.paper,
				border: (theme) => `2px solid ${theme.palette.divider}`,
				cursor: "pointer",

				"&:hover": {
					border: (theme) => `2px solid ${theme.palette.primary.main}`,
				},
				"&:hover:not(:has(.session-select-application-action:hover))": {
					backgroundColor: (theme) => session.impersonator != null ? theme.palette.action.selected : theme.palette.action.hover,
				},
			}}
			onClick={(event) => {
				event.stopPropagation();
				switchSession(session.applicationSessionUuid);
			}}
		>
			<Box>
				<Typography
					variant="body2"
					fontWeight="bold"
					title={session.application.name}
					noWrap
				>
					{session.application.name}
				</Typography>
				{session.application.multitenancyTemplateName && (
					<Typography
						variant="body2"
						title={session.application.multitenancyTemplateName}
						color="text.secondary"
						noWrap
					>
						{session.application.multitenancyTemplateName}
					</Typography>
				)}
				<Typography
					variant="body2"
					color="text.secondary"
					title={session.application.tenantName}
					noWrap
				>
					{session.application.tenantName}
				</Typography>
			</Box>
			<Box display="flex" alignItems="center" gap={1}>
				{currentSessionUuid != null && session.applicationSessionUuid === currentSessionUuid && (
					<Box sx={{
						padding: "2px 6px",
						fontSize: "0.8rem",
						color: (theme) => theme.palette.text.secondary,
						backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.5),
					}}>
						{intl.formatMessage({ id: "CURRENT" })}
					</Box>
				)}
				<Tooltip title={intl.formatMessage({ id: "COASTGUARD_END_SESSION" })}>
					<Box
						className="session-select-application-action"
						sx={{
							padding: 0.5,
							lineHeight: 0,
							"&:hover": {
								backgroundColor: (theme) => theme.palette.action.hover,
							},
						}}
						onClick={(event) => {
							event.stopPropagation();
							logoutSession(session.applicationSessionUuid);
						}}
					>
						<Clear />
					</Box>
				</Tooltip>
			</Box>
		</Box>
	);
};

export default CoastguardSessionSelectApplication;
